import type { ReactNode } from 'react'
import Box, { type BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'

export interface IModalFooterProps extends Omit<BoxProps, 'title'> {
  leftButtons?: ReactNode
  rightButtons?: ReactNode
}

export const ModalFooter: Settle.FC<IModalFooterProps> = ({ leftButtons, rightButtons, children, ...props }) => (
  <Box data-testid="modal-footer" paddingX={{ xs: 2, md: 3 }} paddingY={1.5} {...props}>
    {children}
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1.5 },
      }}
    >
      {leftButtons && (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          {leftButtons}
        </Stack>
      )}
      {rightButtons && (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} ml={{ sm: 'auto' }}>
          {rightButtons}
        </Stack>
      )}
    </Box>
  </Box>
)
